export function TrendStat({
  label,
  value,
  previousValue,
  format,
}: {
  label: string;
  value: number;
  previousValue?: number;
  format?: (n: number) => string;
}) {
  const fmt = format ?? ((n: number) => n.toLocaleString('de-DE'));
  const delta = previousValue != null && previousValue > 0 ? ((value - previousValue) / previousValue) * 100 : null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900">
      <p className="text-xs font-medium text-slate-500 dark:text-slate-400">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-white">{fmt(value)}</p>
      {delta != null && (
        <p className={`mt-1 text-xs font-medium ${delta >= 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-500 dark:text-rose-400'}`}>
          {delta >= 0 ? '↑' : '↓'} {Math.abs(delta).toFixed(1)}% vs. Vorperiode
        </p>
      )}
    </div>
  );
}
